// 구성원 관리 / 초대 (CompanyStaffController, CompanyInvitationController, InvitationController)
//
// 조직 구성원(회사 직원) = 회사 소유자(COMPANY_ADMIN) + 회사 관리자(COMPANY_MANAGER).
// 일반 회원(USER)은 쇼핑몰 고객이라 "회원 관리"에서 다룬다.

export type StaffRole = "COMPANY_ADMIN" | "COMPANY_MANAGER";
export type InvitationStatus = "PENDING" | "ACCEPTED" | "REVOKED" | "EXPIRED";
/** 초대받은 이메일의 계정 상태. IN_COMPANY 이 회사 회원 / ELSEWHERE 다른 회사 계정 / NEW 계정 없음 */
export type InvitationAccountState = "IN_COMPANY" | "ELSEWHERE" | "NEW";
export type InvitationLoginMethod = "EMAIL" | "GOOGLE" | "KAKAO" | "NAVER";

export interface StaffMember {
  userId: number;
  name: string | null;
  email: string | null;
  mobile: string | null;
  role: StaffRole;
  departmentId: number | null;
  departmentName: string | null;
  createdAt: string;
}

export interface CompanyInvitation {
  id: number;
  email: string;
  role: "COMPANY_MANAGER";
  departmentId: number | null;
  departmentName: string | null;
  status: InvitationStatus;
  invitedByName: string | null;
  expiresAt: string;
  createdAt: string;
  acceptedAt: string | null;
}

/** 초대 생성·재발송 결과. 메일 발송 실패여도 초대는 만들어진다 */
export interface InvitationSendResult {
  invitation: CompanyInvitation;
  mailSent: boolean;
}

/** 공개 초대 미리보기 (GET /api/invitations/{token}) */
export interface InvitationPreview {
  companyId: number;
  companyName: string;
  email: string;
  inviterName: string | null;
  expiresAt: string;
  status: InvitationStatus;
  accountState: InvitationAccountState;
  loginMethods: InvitationLoginMethod[];
}

export interface InvitationSignupRequest {
  name: string;
  password: string;
  termsOfServiceAgreed: boolean;
  privacyPolicyAgreed: boolean;
  over14YearsOld: boolean;
  promotionNewsSubscribed: boolean;
}

export const STAFF_ROLE_LABELS: Record<string, string> = {
  COMPANY_ADMIN: "회사 소유자",
  COMPANY_MANAGER: "회사 관리자",
  USER: "회원",
  ADMIN: "시스템 관리자",
};

export const INVITATION_STATUS_LABELS: Record<InvitationStatus, string> = {
  PENDING: "수락 대기",
  ACCEPTED: "수락함",
  REVOKED: "취소됨",
  EXPIRED: "만료됨",
};

/** 소셜 로그인 시작 전 저장하고, 콜백(AuthSuccessPage)에서 꺼내 초대 수락으로 이어 간다 */
export const PENDING_INVITATION_TOKEN_KEY = "pendingInvitationToken";
